type Props = {
  children: React.ReactNode
}

function Root({ children }: Props) {
  return <div className="root-elem">{children}</div>
}

export default Root
